module.exports = __webpack_public_path__ + "media/packs/images/flags/SK-2c87c786566e86df32ce2491566ac652.svg";